import flatten from "lodash-es/flatten";
import { Reducer } from "redux";

import {
    STROLLER_REVIEW_PHOTO_FETCH_FAILURE,
    STROLLER_REVIEW_PHOTO_FETCH_REQUEST,
    STROLLER_REVIEW_PHOTO_FETCH_SUCCESS,
    StrollerReviewPhotoFetchFailureAction,
    StrollerReviewPhotoFetchRequestAction,
    StrollerReviewPhotoFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhoto.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";
import { StrollerUserReviewEntity, StrollerUserReviewSchema } from "@/mk2/schemas";
import { getDenormalizedEntities } from "@/mk2/selectors";

export interface StrollerReviewPhotoState {
    loadingState: LoadingState;
    errorMessage: string;
    strollerId: number | null;
    strollerReviewId: number | null;
    strollerReviewPhotoIds: number[];
}

export const initialStrollerReviewPhotoState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    strollerId: null,
    strollerReviewId: null,
    strollerPendingReviewIds: [],
    strollerReviewPhotoIds: [],
    strollerAlikeStrollerIds: [],
};

export interface StrollersReviewsPhotosState {
    [strollerSlug: string]: StrollerReviewPhotoState;
}

const initialStrollersReviewsPhotosState: StrollersReviewsPhotosState = {};

declare type StrollersReviewsPhotosReducerAction =
    | StrollerReviewPhotoFetchRequestAction
    | StrollerReviewPhotoFetchSuccessAction
    | StrollerReviewPhotoFetchFailureAction;

export const strollersReviewsPhotosReducer: Reducer<
    StrollersReviewsPhotosState,
    StrollersReviewsPhotosReducerAction
> = (state = initialStrollersReviewsPhotosState, action) => {
    switch (action.type) {
        case STROLLER_REVIEW_PHOTO_FETCH_REQUEST:
        case STROLLER_REVIEW_PHOTO_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewPhotoState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case STROLLER_REVIEW_PHOTO_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewPhotoState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                    strollerId: action.response.result.stroller,
                    strollerReviewId: action.response.result.strollerReviews[0],
                    // collect all review photos
                    strollerReviewPhotoIds: flatten(
                        getDenormalizedEntities<StrollerUserReviewEntity>(
                            action.response,
                            StrollerUserReviewSchema,
                            action.response.result.strollerReviews,
                        ).map((review) => review.photos),
                    ).map((photo) => photo.id),
                }),
            });
        }

        default:
            return state;
    }
};
